/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { quartierSchema } from "../quartierSchema.ts";
import { z } from "zod";

export const getQuartiersQueryParamsSchema = z.object({
      "codeInsee": z.string().regex(/^[0-9][0-9AB][0-9]{3}$/).describe("Code INSEE de la commune (cinq caractères, `2A`/`2B` pour la Corse).")
      })

/**
 * @description La liste des quartiers de la commune est retournée (vide si la commune n\'en a aucun).
 */
export const getQuartiers200Schema = z.array(z.lazy(() => quartierSchema).describe("Quartier (zone IRIS) d'une commune, issu de la table `localite` du datalake."))

export const getQuartiersQueryResponseSchema = z.lazy(() => getQuartiers200Schema)